import {
  QA_NAME_VIEWING_PROFILE_ACTION,
  VIEWING_PROFILE_ACTION,
} from '../RentalPortalViewingProfile.constants'
import {
  getCanEditViewingNote,
  getCanRescheduleViewing,
  getHasViewingStarted,
  getIsViewingCalendarExportable,
  getIsViewingTerminal,
} from '../RentalPortalViewingProfile.utils'

import {
  VIEWING_PROFILE_FOOTER_ACTION_ITEMS,
  VIEWING_PROFILE_FOOTER_ACTION_TEXT_KEY,
  VIEWING_PROFILE_FOOTER_LIFECYCLE_ACTION_ICON,
  VIEWING_PROFILE_FOOTER_LIFECYCLE_ACTION_PERMISSION_NAME,
} from './RentalPortalViewingProfileHeaderFooter.constants'

function getIsViewingProfileFooterActionPermitted({ action, viewingData }) {
  const isTerminal = getIsViewingTerminal(viewingData)

  const canManage = Boolean(viewingData?.permissions?.can_manage)

  switch (action) {
    case VIEWING_PROFILE_ACTION.addNote:
      return getCanEditViewingNote(viewingData)

    case VIEWING_PROFILE_ACTION.addToCalendar:
      return getIsViewingCalendarExportable(viewingData)

    case VIEWING_PROFILE_ACTION.reschedule:
      return getCanRescheduleViewing(viewingData)

    case VIEWING_PROFILE_ACTION.uploadDocument:
      return canManage

    default:
      return !isTerminal
  }
}

function getIsViewingProfileCompletedAction(action) {
  return action === VIEWING_PROFILE_ACTION.completed
}

function getIsViewingProfileNoShowAction(action) {
  return action === VIEWING_PROFILE_ACTION.noShow
}

function getViewingProfileFooterActionTooltipKey({ action, viewingData }) {
  const isOutcomeAction =
    getIsViewingProfileCompletedAction(action) ||
    getIsViewingProfileNoShowAction(action)

  return isOutcomeAction && !getHasViewingStarted(viewingData)
    ? 'RentalPortal.ViewingOutcomeNotStartedTooltipKey'
    : null
}

function getViewingProfileFooterLifecycleActionItem({ t, viewingData }) {
  const lifecycleAction = viewingData?.archived
    ? VIEWING_PROFILE_ACTION.restore
    : VIEWING_PROFILE_ACTION.archive

  return viewingData?.permissions?.[
    VIEWING_PROFILE_FOOTER_LIFECYCLE_ACTION_PERMISSION_NAME[lifecycleAction]
  ]
    ? {
        Icon: VIEWING_PROFILE_FOOTER_LIFECYCLE_ACTION_ICON[lifecycleAction],
        action: lifecycleAction,
        qaName: QA_NAME_VIEWING_PROFILE_ACTION[lifecycleAction],
        text: t(VIEWING_PROFILE_FOOTER_ACTION_TEXT_KEY[lifecycleAction]),
      }
    : null
}

export function getViewingProfileFooterActions({ t, viewingData }) {
  const actions = VIEWING_PROFILE_FOOTER_ACTION_ITEMS.filter(({ action }) =>
    getIsViewingProfileFooterActionPermitted({ action, viewingData })
  ).map(({ Icon, action }) => {
    const tooltipKey = getViewingProfileFooterActionTooltipKey({
      action,
      viewingData,
    })

    return {
      Icon,
      action,
      disabled: Boolean(tooltipKey),
      qaName: QA_NAME_VIEWING_PROFILE_ACTION[action],
      text: t(VIEWING_PROFILE_FOOTER_ACTION_TEXT_KEY[action]),
      tooltipKey,
    }
  })

  const lifecycleActionItem = getViewingProfileFooterLifecycleActionItem({
    t,
    viewingData,
  })

  return lifecycleActionItem ? [...actions, lifecycleActionItem] : actions
}

export function getViewingProfileFooterMoreOptions({ actions, t }) {
  return actions.map(({ action, disabled, text, tooltipKey }) => ({
    disabled,
    label: text,
    tooltipContent: tooltipKey ? t(tooltipKey) : null,
    value: action,
  }))
}
